import { Navigate, Route } from "react-router";

import { queryClient } from "@/providers/QueryClient";
import { loadSearchTablePreferences } from "@/shared/domain/config/loaders/loadSearchTablePreferences";
import { QueryTarget } from "@/shared/domain/query";
import { makeViewsLoader } from "@/shared/domain/views/loaders/loadViews";
import { Goto } from "@/shared/navigation";
import { composeLoaders } from "@/shared/routing/composeLoaders";
import { RedirectToDefaultTab } from "@/shared/routing/RedirectToDefaultTab";

import { Collection } from "./Collection";
import { CollectionAudit } from "./Collection/CollectionAudit";
import { CollectionDetailsTab } from "./Collection/CollectionDetailsTab";
import { CollectionItemsTab } from "./Collection/CollectionItemsTab";
import { CollectionPermissionDetails } from "./Collection/CollectionPermissionDetails";
import { CollectionTab } from "./Collection/useActiveCollectionTabFromUrl";
import { loadCollectionRecord } from "./loaders";
import { Collections } from "./ViewCollections";

export const CollectionsRoutes = () => [
  <Route
    key="/"
    index
    loader={composeLoaders(
      loadSearchTablePreferences(
        queryClient,
        "collection_search_table_preferences",
      ),
      // See `DatasetsRoutes`: resolves a `?view=` link before the list mounts.
      makeViewsLoader(queryClient, { target: QueryTarget.Collections }),
    )}
    element={<Collections />}
  />,
  <Route
    key=":collectionId"
    path=":collectionId"
    loader={loadCollectionRecord(queryClient)}
    shouldRevalidate={({ currentParams, nextParams }) =>
      currentParams.collectionId !== nextParams.collectionId
    }
    element={<Collection />}
  >
    <Route index element={<Navigate to={CollectionTab.Items} replace />} />
    <Route path={CollectionTab.Items} element={<CollectionItemsTab />} />
    <Route path={CollectionTab.Details} element={<CollectionDetailsTab />} />
    <Route path={CollectionTab.Activity} element={<CollectionAudit />} />
    <Route
      path={CollectionTab.Permissions}
      element={<CollectionPermissionDetails />}
    />
    <Route
      path="*"
      element={
        <RedirectToDefaultTab
          buildPath={({ collectionId }) =>
            `${Goto.route.Collections}/${collectionId}/${CollectionTab.Items}`
          }
        />
      }
    />
  </Route>,
];
